
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"19","height":"23","viewBox":"0 0 19 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.5 23l-6.718-6.737A9.552 9.552 0 01.722 5.881a9.521 9.521 0 013.5-4.275 9.48 9.48 0 0110.556 0 9.52 9.52 0 013.499 4.275 9.552 9.552 0 01-2.06 10.382L9.5 23zm5.225-8.233a7.43 7.43 0 001.601-8.075 7.406 7.406 0 00-2.721-3.326 7.374 7.374 0 00-8.21 0 7.405 7.405 0 00-2.721 3.326 7.43 7.43 0 001.601 8.075l5.225 5.24 5.225-5.24zM9.5 11.644c-.56 0-1.097-.223-1.493-.62A2.12 2.12 0 019.5 7.41c.56 0 1.097.223 1.493.62a2.12 2.12 0 010 2.994c-.396.397-.933.62-1.493.62z","fill":"#000"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Lead/ToggleBtn/assets/pin.svg
// module id = 0zTl
// module chunks = 1